import type { TypeSelectOption } from '@thefarmersfront/kitchen';

/**
 * 객체 배열을 Select 컴포넌트의 옵션 형식으로 변환하는 함수
 * @param options - 변환할 객체 배열
 * @param valueKey - value로 사용할 키 이름
 * @param textKey - text로 사용할 키 이름
 * @param textFormatter - text 형식 변환 함수
 * @returns Select 컴포넌트에서 사용할 수 있는 옵션 배열
 */

const transformToSelectOptions = <T extends Record<string, unknown>, V extends string | number = string>(
  options: T[],
  valueKey: keyof T,
  textKey: keyof T,
  textFormatter?: (value: V, text: string) => string
): TypeSelectOption<V>[] => {
  return options?.map((option) => {
    const rawValue = option[valueKey];
    const value = (rawValue ?? '') as V;
    const text = String(option[textKey] ?? '');

    return {
      value,
      text: textFormatter ? textFormatter(value, text) : text,
    };
  });
};

export default transformToSelectOptions;
